
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var parcelRequire = $parcel$global["parcelRequire34b5"];
var parcelRegister = parcelRequire.register;
parcelRegister("79Co0", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", function () { return $5357265f3c0ead18$export$2e2bcd8739ae039; });

var $f53LC = parcelRequire("f53LC");

var $03EZb = parcelRequire("03EZb");
function $5357265f3c0ead18$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $5357265f3c0ead18$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $5357265f3c0ead18$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $f53LC.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $5357265f3c0ead18$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $5357265f3c0ead18$var$createTerminalErrorPayload(errorData, context) {
    var _window$location;
    var config = (0, $03EZb.getConfig)();
    if (!config) return null;
    return {
        actionSubject: 'experience',
        action: 'measured',
        eventType: 'operational',
        source: 'measured',
        tags: [
            'observability'
        ],
        attributes: {
            properties: $5357265f3c0ead18$var$_objectSpread({
                'event:hostname': ((_window$location = window.location) === null || _window$location === void 0 ? void 0 : _window$location.hostname) || 'unknown',
                'event:product': config.product,
                'event:schema': '1.0.0',
                'event:source': {
                    name: 'react-ufo/web',
                    version: '1.0.1'
                },
                'event:region': config.region || 'unknown',
                'experience:key': 'custom.terminal-error',
                terminalError: errorData
            }, context)
        }
    };
}
var $5357265f3c0ead18$export$2e2bcd8739ae039 = $5357265f3c0ead18$var$createTerminalErrorPayload;

});


//# sourceMappingURL=create-terminal-error-payload.9a312b8a.js.map
